import type { VipType } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/type';
import { ICommentInfo } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import type { CommentType, ICTPoint2DDelta, ITextAnchor } from '@tencent/slide-sdk-pb-model';

/**
 * 批注接口的返回数据格式
 * https://iwiki.woa.com/pages/viewpage.action?pageId=4006903415
 */
export interface ICommentData {
    id: string;
    content: string;
    update_time: number;
    nick: string;
    avatar: string;
    publisher: string;
    vip_info?: string;
}

/**
 * 批注后台变更后，推送的通知的数据格式
 */
export interface INotifyCommentData {
    anchor: string,
    author: string,
    author_name: string,
    commentid: string,
    content: string,
    head_url: string,   // 头像链接
    repliedid: string,
    sheet_id: string
    time: string
}

export enum CommentOp {
    add = 'add',    // 添加批注
    del = 'del',    // 删除单条批注
    clear = 'clear',    // 删除整组批注
    mod = 'mod', // 修改批注
}

export interface ICommentVipInfo {
    vipLevel: number,
    avatarFrameUrl: string,
    badgeUrl: string,
    renewalStatus: number,
    expiredStatus: number,
    vipType?: VipType,
}
export type ICommentWithVipInfo = ICommentInfo & Partial<ICommentVipInfo>;

export interface IAddOrUpdateCommentApi {
    addComment: (anchorId: string, content: string) => Promise<undefined>;
    updateComment: (commentId: string, anchorId: string, content: string) => Promise<undefined>;
}

export interface IDeleteCommentApi {
    deleteComment: (anchorId: string, commentId: string) => Promise<undefined>;
    deleteCommentGroup: (anchorId: string) => void;
}

export interface ICommentApi extends IAddOrUpdateCommentApi, IDeleteCommentApi {
}

export type IGroupId = string;

/**
 * 背景批注
 */
export interface ISlideCommentGroup {
    /**
     * 批注的类型
     */
    commentType: CommentType;
    /**
     * 批注在页面中的角标显示位置。当该值不存在时，默认在对应锚点的左上角。
     */
    anchorPosition?: ICTPoint2DDelta;
}

/**
 * 元素批注
 */
export interface IElementCommentGroup extends ISlideCommentGroup {
    /**
     * 批注所属的形状的 ID
     */
    shapeId: string;
}

/**
 * 文字批注
 */
export interface ITextCommentGroup extends IElementCommentGroup {
    /**
     * 文字批注的锚点位置
     */
    textAnchor: ITextAnchor;
}

export type ICommentGroup = ISlideCommentGroup | IElementCommentGroup | ITextCommentGroup;

export type ICommentGroupMap = Map<string, ICommentGroup>;

export type PendingCommentGroup = { groupId: string, commentGroup: ICommentGroup } | undefined;
